import { reactive } from "vue";

import BKCart from "@/module/ShoppingCart/service/BKCart";

const state = reactive({
    cartCount: 0,
    arrCartItem: []
});
const methods = {
    apiGetCartCount: function () {
        return new Promise((resolve, reject) => {
            BKCart.apiGetCartItem().subscribe({
                next: (arrCartItem) => {
    
                    state.arrCartItem = arrCartItem;
                    var total = 0;
                    var list = arrCartItem;
                    if (list) {
                        for (var items of list) {
                            total += items.quantity;
                        }
                    }
                    state.cartCount = total;
                    resolve(total);
                },
                error: (err) => {
                    // console.log(err);
                    reject(err)
                },
            });
        })
    },
    updateCartCount: function () {
        return this.apiGetCartCount();
    },
    updateCartCountFromCartItem: function (list) {
        let total = 0;
        
        if (list) {
            for (let items of list) {
                total += items.quantity;
            }
        }
        state.cartCount = total;
    },
    deleteCartAll: async function () {
        await this.apiDeleteCartItemAll();
        this.updateCartCount();
    },
    apiDeleteCartItemAll: async function() {
        return new Promise((resolve) => {
            BKCart.apiDeleteCartItemAll().subscribe({
                next: (data) => {
                    console.log(data);
                    resolve(true);
                },
                error: (err) => {
                    resolve(false);
                    this.errorApi(err);
                },
            });
        });
    },
};

export default {
    state: state,
    methods: methods,
}
